export const stockguardDomain = 'stockguard.io';

export const harvestiqDomain = 'harvestiq.com';

export const stockguardEmailAddress = `info@${stockguardDomain}`;

export const harvestiqEmailAddress = `info@${harvestiqDomain}`;

export const stockguardPhoneNumber = '5152725177';

export const harvestiqPhoneNumber = stockguardPhoneNumber;

export const InsureIQAppLogoUrl =
  'https://cdn.harvestiq.com/branding/harvestiq/harvestiq-logo-inline.png';

export const InsureIQAppLogoCompactUrl =
  'https://cdn.harvestiq.com/branding/harvestiq/hiq-logo-compact.svg';

export const InsureIQFaviconUrl =
  'https://cdn.harvestiq.com/branding/harvestiq/favicon.ico';
